import React from "react";
import { Box } from '@mui/material';
import Navbar from "./Navbar/NavbarComponent";
import { Outlet } from "react-router-dom";
import Footer from "./Footer/Footer";

const Layout = () => {

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      <Navbar />
      <Outlet />
      <Footer />
    </Box>
  );
};

export default Layout;
